<template>
  <div class="round-item-wrap">
    <!-- 第一轮  -->
    <div class="round1-level-wrap" v-if="round === 'round1' && checkpoints[0]">
      <!-- 未开始或已结束 -->
      <div
        class="disable-round1 round-content"
        :class="checkpoints[0].finished ? '' : 'will-round1'"
        v-if="!checkpoints[0].doing"
      >
        <div class="round-text">
          <div class="round-title">{{ checkpoints[0].level_name }}</div>
          <div
            class="round-item-desc"
            v-for="list in checkpoints[0].descriptions"
            :key="list"
          >
            {{ list }}
          </div>
          <div class="round-status-text">
            {{ checkpoints[0].finished ? '已结束' : '未启动' }}
          </div>
        </div>
        <img class="round-img" alt="关卡" :src="checkpoints[0].img" />
      </div>
      <!-- 进行中 -->
      <template v-else>
        <div class="round-content">
          <div class="round-text">
            <div class="round-title">
              {{ checkpoints[0].level_name }}
              <span class="round-now"
                ><span class="icon-wrap"
                  ><h-icon
                    name="fireball"
                    style="color: #ffd700"
                  ></h-icon></span
                >进行中</span
              >
            </div>
            <div class="round-date">
              <h-icon name="ios-time"></h-icon>
              {{ checkpoints[0].time[0] + '-' + checkpoints[0].time[1] }}
            </div>
            <div
              class="round-item-desc"
              v-for="list in checkpoints[0].descriptions"
              :key="list"
            >
              {{ list }}
            </div>
          </div>
          <div class="round-img-wrap">
            <img
              class="round-img"
              alt="二维码"
              :src="answerQrCode"
              v-if="answerQrCode"
            />
            <div>扫码参赛赢好礼</div>
          </div>
        </div>
      </template>
    </div>
    <!-- 第二轮 -->
    <div v-else class="round2-level-wrap">
      <div
        class="round-content"
        :class="{
          'round-active': index === round2CurIndex,
          'disable-round2-wrap': item.finished
        }"
        v-for="(item, index) in checkpoints"
        :key="item.round"
        @mouseenter="handleMouseEnter(item, index)"
      >
        <!-- 只有创想题才有可选标志 -->
        <span class="choose-tag" v-if="index === 2"></span>
        <!-- 关卡没有结束的情况下，对应展示 -->
        <template v-if="index === round2CurIndex && !item.finished">
          <div class="round-text" v-show="showRound2Text">
            <div class="round-title">
              {{ item.level_name }}
              <span class="round-now" v-if="item.doing"
                ><span class="icon-wrap"
                  ><h-icon
                    name="fireball"
                    style="color: #ffd700"
                  ></h-icon></span
                >进行中</span
              >
            </div>
            <div class="round-date">
              <h-icon name="ios-time"></h-icon>
              {{ item.time[0] + '-' + item.time[1] }}
            </div>
            <div
              class="round-item-desc"
              :class="index === 0 ? `round2-item-special-desc` : ''"
              v-for="list in item.descriptions"
              :key="list"
            >
              {{ list }}
            </div>
            <a
              rel="noopener,noreferrer"
              href="javascript:;"
              class="submit-btn"
              v-if="index && item.doing"
              @click="handleBtnClick(index)"
              >{{ index === 3 ? '立即查看' : '提交作品' }}</a
            >
          </div>
          <img
            class="round-img"
            alt=""
            :src="item.img"
            v-show="showRound2Text"
          />
        </template>
        <template class="disable-content" v-else>
          <div class="round-title">
            {{ item.level_name }}
          </div>
          <div class="round-date">
            <h-icon name="ios-time"></h-icon>
            {{ item.time[0] + '-' + item.time[1] }}
          </div>
          <img class="round-img" alt="暂未开始" :src="item.img" />
          <div
            class="round-status"
            :class="`round-status${item.level_state}`"
          >
            {{ handleClosedText(item, index) }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { bus } from '../../../config'
export default {
  name: '',
  props: {
    checkpoints: {
      type: Array,
      default: () => []
    },
    // 大赛轮次
    round: {
      type: String,
      default: 'round1'
    }
  },
  data() {
    return {
      answerQrCode: window.financialCompetitionResource.answerQrCode, // 答题地址二维码
      round2CurIndex: 0,
      submitUrl: window.financialCompetitionResource.submitUrl, // 提交作品地址
      showRound2Text: true // 展示round2关卡介绍文案
    }
  },
  created() {
    this.caculateActiveLevel(this.checkpoints)
  },
  mounted() {},
  methods: {
    // 处理鼠标进入卡片
    handleMouseEnter(item, index) {
      if (index === this.round2CurIndex || item.finished) {
        return
      }
      this.round2CurIndex = index
      this.showRound2Text = false
      setTimeout(() => {
        this.showRound2Text = true
      }, 200)
    },
    // 处理卡片按钮点击
    handleBtnClick(index) {
      if (index === 1 || index === 2) {
        window.open(this.submitUrl)
      }
      if (index === 3) {
        bus.$emit('showRankList')
      }
    },
    // 计算第二轮初始化时的默认展开关卡
    caculateActiveLevel(arr) {
      if (arr.length === 1) {
        // 第一轮不做处理
        this.round2CurIndex = -1
        return
      }
      // 将round2中的第一个进行中的关卡设置成展开状态
      for (let i = 0, len = arr.length; i < len; i++) {
        if (!arr[i].finished) {
          this.round2CurIndex = i
          break
        }
      }
    },
    // 处理卡片未展开时展示的按钮文字
    handleClosedText(item, index) {
      if (item.finished) {
        return '已结束'
      }
      if (index === 0) {
        return '赛题介绍'
      }
      if (index === 3) {
        return '立即查看'
      }
      return '提交作品'
    }
  },
  watch: {
    checkpoints: {
      handler(val) {
        this.caculateActiveLevel(val)
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.round-item-wrap {
  margin: 32px 0 37px;
  .round-now {
    margin: 0 0 8px 6px;
    font-family: 'PingFangSC-Medium', Arial, 'Microsoft Yahei', sans-serif,
      Verdana, 'PingFang SC';
    display: inline-block;
    height: 14px;
    font-size: 10px;
    line-height: 14px;
    color: #fff;
    position: relative;
    background-image: linear-gradient(42deg, #ff3030 0%, #8046f2 100%);
    box-shadow: 0 4px 8px 0 rgba(48, 60, 250, 0.25);
    border-radius: 7px;
    padding: 0 5px 0 21px;
    font-weight: normal;
    .icon-wrap {
      position: absolute;
      left: -2px;
      bottom: 0;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      height: 20px;
      width: 20px;
      border-radius: 50%;
      background-color: #ccc;
      background-image: linear-gradient(222deg, #fe9807 0%, #ff2f2f 53%);
      box-shadow: 1px 1px 3px 0 rgba(240, 19, 19, 0.42);
    }
  }

  .round-title {
    height: 34px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #333;
    line-height: 34px;
    font-weight: 500;
    margin-bottom: 8px;
  }
  .round-date {
    height: 24px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #666;
    line-height: 24px;
    font-weight: 500;
    margin-bottom: 16px;
  }
  .round-item-desc {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666;
    line-height: 22px;
    font-weight: 400;
    margin: 8px 0;
    &::before {
      content: '';
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #666;
      margin-right: 8px;
    }
  }
}
.round1-level-wrap {
  // margin-top: 26px;
  .round-status-text {
    height: 42px;
    font-family: PingFangSC-Medium;
    font-size: 30px;
    color: #bbb;
    line-height: 42px;
    font-weight: 500;
    margin-top: 40px;
  }
  .round-img {
    width: 220px;
    height: 220px;
  }
  .round-content {
    width: 1136px;
    height: 340px;
    border-radius: 25px;
    padding: 33px 70px 37px 40px;
    font-family: PingFangSC-Medium;
    display: flex;
    background-color: #f0f6ff;
    justify-content: space-between;
    .round-title {
      font-size: 24px;
    }
    .round-text {
      width: 300px;
      margin-right: 91px;
    }
    .round-img-wrap {
      font-size: 18px;
      color: #666;
      text-align: center;
      font-weight: 600;
      margin-right: 41px;
    }
    .round-img {
      width: 245px;
      height: 224px;
      margin-bottom: 20px;
    }
  }
}
.disable-round1 {
  background-color: #f7f7f7 !important;
  border-radius: 25px;
  padding: 62px;
  font-family: PingFangSC-Medium;
  display: flex;
  .round-item-desc::before {
    display: none;
  }
  .round-text {
    width: 450px;
  }
}
.will-round1 {
  background-color: #f0f6ff;
}

.round2-level-wrap {
  display: flex;
  .round-content {
    min-width: 166px;
    flex: 1;
    height: 337px;
    border-radius: 25px;
    background-color: #f7f7f7;
    margin-right: 12px;
    padding: 22px;
    flex-direction: column;
    align-items: center;
    display: flex;
    transition: 400ms;
    position: relative;
    .choose-tag {
      width: 54px;
      height: 54px;
      position: absolute;
      top: 0;
      right: 0;
      background: url('~@/assets/financialCompetition/choose_pic@2x.png')
        center/contain no-repeat;
    }
    &:last-of-type {
      margin-right: 0;
    }
    .round-title {
      font-size: 24px;
    }
    .round-img {
      width: 123px;
      height: 123px;
      margin: 19px 0 25px;
    }
    .round-status {
      width: 135px;
      height: 36px;
      border: 0.5px solid rgba(216, 216, 216, 1);
      border-radius: 18px;
      font-size: 14px;
      color: #303030;
      text-align: center;
      line-height: 36px;
      font-weight: 500;
    }
    .round-status2 {
      color: #999;
    }
  }
  .round-active {
    height: 337px;
    background-color: #f0f6ff;
    flex-direction: row;
    align-items: initial;
    min-width: 603px;
    width: 603px;
    .disable-content {
      opacity: 0;
    }
    .round-text {
      width: 330px;
      margin-right: 22px;
    }
    .round-item-desc {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #666;
      line-height: 22px;
      &::before {
        display: inline-block;
        content: '';
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #666;
        margin-right: 2px;
      }
    }
    // 第二阶段第一关“码上较量”最后一段介绍文案高亮
    .round2-item-special-desc {
      &:last-of-type {
        color: #0011bb;
        &::before {
          background-color: #0011bb;
        }
      }
    }
    .submit-btn {
      width: 135px;
      height: 36px;
      background-image: linear-gradient(to right, #0011bb, #25fbff);
      border-radius: 19px;
      line-height: 36px;
      text-align: center;
      font-size: 14px;
      color: #fff;
      font-weight: 500;
      position: absolute;
      bottom: 26px;
      left: 24px;
    }
    .round-img {
      width: 200px;
      height: 200px;
      margin: 83px 0 0;
    }
  }
  .disable-round2-wrap {
    min-width: 166px;
    background: #f7f7f7;
    border-radius: 25px;
    font-family: PingFangSC-Medium;
    flex-direction: column;
    // justify-content: center;
    align-items: center;
    text-align: center;
    .round-title {
      height: 34px;
      font-size: 24px;
      color: #333;
      letter-spacing: 0;
      line-height: 34px;
      font-weight: 500;
    }
    .round-teim-desc {
      height: 22px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #666;
      line-height: 22px;
      font-weight: 400;
      margin: 8px 0 40px;
    }
    .round-img {
      width: 126px;
      height: 126px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/competeRound/components/roundComponent.vue